
import React from "react";
import { useAdminWorksheetCheck } from "@/hooks/useAdminWorksheetCheck";
import { ReportLoading } from "@/components/reports/ReportLoading";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { WorksheetCheckTable } from "@/components/admin/worksheet/WorksheetCheckTable";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Tag } from "lucide-react";
import { useWorksheetFiltering } from "@/hooks/useWorksheetFiltering";

const AdminWorksheetCheck: React.FC = () => {
  const {
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    showOtherSubjectsOnly,
    setShowOtherSubjectsOnly,
    sortField,
    sortDirection,
    currentPage,
    setCurrentPage,
    handleSort,
    resetFilters
  } = useWorksheetFiltering({
    reports: [],
    totalCount: 0,
    itemsPerPage: 20
  });

  const { reports, totalCount, isLoading, refetch } = useAdminWorksheetCheck({
    page: currentPage,
    itemsPerPage: 20,
    searchQuery,
    statusFilter,
    showOtherSubjectsOnly,
    sortField,
    sortDirection
  });

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <h1 className="text-2xl font-bold mb-6">ตรวจสอบ Worksheet รายงานนักเรียน</h1>
            
            <Alert className="mb-4">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                สามารถค้นหา กรอง และเรียงลำดับข้อมูลได้ และแก้ไขผลการตรวจและเหตุผลได้โดยคลิกที่สถานะ 
                และคลิกปุ่มแก้ไข ระบบจะบันทึกประวัติการแก้ไขโดยอัตโนมัติ <span className="font-medium">หัวข้อที่เป็น "หัวข้ออื่นๆ" 
                จะมี <Tag className="inline h-3 w-3 text-amber-600" /> แท็กกำกับไว้ และคุณสามารถกรองเพื่อดูเฉพาะหัวข้อเหล่านั้นได้</span>
              </AlertDescription>
            </Alert>
            
            {isLoading ? (
              <ReportLoading />
            ) : (
              <WorksheetCheckTable 
                reports={reports} 
                totalCount={totalCount}
                refetch={refetch}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                statusFilter={statusFilter}
                setStatusFilter={setStatusFilter}
                showOtherSubjectsOnly={showOtherSubjectsOnly}
                setShowOtherSubjectsOnly={setShowOtherSubjectsOnly}
                sortField={sortField}
                sortDirection={sortDirection}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                handleSort={handleSort}
                resetFilters={resetFilters}
              />
            )}
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminWorksheetCheck;
